/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AllocatedPremiumScheduleResponseDto } from './AllocatedPremiumScheduleResponseDto';
import {
    AllocatedPremiumScheduleResponseDtoFromJSON,
    AllocatedPremiumScheduleResponseDtoFromJSONTyped,
    AllocatedPremiumScheduleResponseDtoToJSON,
    AllocatedPremiumScheduleResponseDtoToJSONTyped,
} from './AllocatedPremiumScheduleResponseDto';

/**
 * 
 * @export
 * @interface AllocatedPremiumScheduleListResponseDto
 */
export interface AllocatedPremiumScheduleListResponseDto {
    /**
     * 
     * @type {Array<AllocatedPremiumScheduleResponseDto>}
     * @memberof AllocatedPremiumScheduleListResponseDto
     */
    premiumSchedules: Array<AllocatedPremiumScheduleResponseDto>;
}

/**
 * Check if a given object implements the AllocatedPremiumScheduleListResponseDto interface.
 */
export function instanceOfAllocatedPremiumScheduleListResponseDto(value: object): value is AllocatedPremiumScheduleListResponseDto {
    if (!('premiumSchedules' in value) || value['premiumSchedules'] === undefined) return false;
    return true;
}

export function AllocatedPremiumScheduleListResponseDtoFromJSON(json: any): AllocatedPremiumScheduleListResponseDto {
    return AllocatedPremiumScheduleListResponseDtoFromJSONTyped(json, false);
}

export function AllocatedPremiumScheduleListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllocatedPremiumScheduleListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'premiumSchedules': ((json['premiumSchedules'] as Array<any>).map(AllocatedPremiumScheduleResponseDtoFromJSON)),
    };
}

export function AllocatedPremiumScheduleListResponseDtoToJSON(json: any): AllocatedPremiumScheduleListResponseDto {
    return AllocatedPremiumScheduleListResponseDtoToJSONTyped(json, false);
}

export function AllocatedPremiumScheduleListResponseDtoToJSONTyped(value?: AllocatedPremiumScheduleListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'premiumSchedules': ((value['premiumSchedules'] as Array<any>).map(AllocatedPremiumScheduleResponseDtoToJSON)),
    };
}

